<template>
    <div>
        <div style="text-align: center; margin-top: 20px;" v-if="channel === 0">成都凯唯科技有限公司是专业心理测评平台</div>
        <div style="text-align: center; margin-top: 20px;" v-if="channel === 0">
            电话: 028-89167288
            &nbsp;
            地址: 高新区天府三街迈普大厦
        </div>
        <div class="footer" v-if="channel === 0">
            版权所有@
            <a href="http://www.askpsyc.com/">成都凯唯科技有限公司</a>
            蜀ICP备20003863号
        </div>
        <div class="footer" v-else-if="channel === 1">
            版权所有@
			宁波芸雅网络科技有限公司福州分公司
        </div>
        <div class="footer" v-else-if="channel === 2">
            版权所有@
            宁波德阅教育信息咨询有限公司福州分公司
        </div>
    </div>
</template>

<script>
    import Func from '@/utils/func'

    export default {
        data() {
            return {
                channel: 0,
            }
        },
        async mounted() {
            // 框架户判定
            this.channel = Func.checkChannel()
        }
    }
</script>

<style lang="scss">
    .footer {
        text-align: center;
        color: #959292;
        padding: 20px 0;

        a {
            color: #959292;
            text-decoration: none;
        }
    }
</style>
